import { Component } from 'react'
import style from './Privilege.css'

export default class Privilege extends Component {
  render () {
    const { page, children } = this.props
    const isAuthorized = (page && page.privilege.authorized) || false

    return isAuthorized
      ? children
      : (
        <div className={style.content}>
          <h1 className={style.message}>你的權限不足，無法使用此功能。</h1>
        </div>
      )
  }
}
